import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import {
  Form,
  FormTextField,
  SubmitButton,
  CancelButton,
  FormRadioGroup,
} from "@covertree/ui";

import { CoverageType } from "@enums";
import { CoverageTypeFormData, coverageTypeFormValidationSchema } from "@forms";
import useAppDispatch from "@redux/hooks/useAppDispatch";
import { useAppSelector } from "@redux/hooks/useAppSelector";
import {
  selectCoverageType,
  selectCtPolicyLocator,
  setCoverageType,
} from "@redux/coverages/coveragesSlice";

interface CoverageTypeFormProps {
  onSubmit: (formData: CoverageTypeFormData) => Promise<void>;
  onClose: () => void;
}

const COVERAGE_TYPES = [
  {
    title: CoverageType.Covertee,
    value: CoverageType.Covertee,
  },
  {
    title: CoverageType.External,
    value: CoverageType.External,
  },
];

export default function CoverageTypeForm({
  onSubmit,
  onClose,
}: CoverageTypeFormProps) {
  const dispatch = useAppDispatch();
  const selected = useAppSelector(selectCoverageType);
  const policyLocator = useAppSelector(selectCtPolicyLocator);

  const {
    control,
    handleSubmit,
    formState: { isValid, isSubmitting },
  } = useForm({
    defaultValues: {
      policyId: policyLocator,
      coverageType: selected,
    },
    mode: "all",
    resolver: yupResolver(coverageTypeFormValidationSchema),
  });

  const handleChangeCoverageType = (selected: CoverageType) => {
    dispatch(setCoverageType(selected));
  };

  return (
    <>
      <Typography
        variant="h3"
        mb={4}
        pl={1}
        sx={{ backgroundColor: "background.default" }}>
        Policy Type
      </Typography>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Grid container spacing={1}>
          <Grid item xs={12}>
            <FormRadioGroup
              items={COVERAGE_TYPES}
              label="Select your policy type"
              selected={selected}
              control={control}
              name="coverageType"
              onOptionSelect={handleChangeCoverageType}
            />
          </Grid>
          {selected === CoverageType.Covertee && (
            <Grid item xs={12}>
              <FormTextField
                id="policyId"
                name="policyId"
                label="Policy ID"
                control={control}
                disabled={isSubmitting}
              />
            </Grid>
          )}
          <Grid item xs={12} container gap={2}>
            <SubmitButton
              width={200}
              loading={isSubmitting}
              disabled={isSubmitting || !isValid}>
              Continue
            </SubmitButton>
            <CancelButton onCancel={onClose} width={200} />
          </Grid>
        </Grid>
      </Form>
    </>
  );
}
